import {CmsContent, SmallPrint} from '@sdox/ui'

export interface FooterDisclaimersProps {
  disclaimers?: string[]
}

export const FooterDisclaimers = ({disclaimers = []}: FooterDisclaimersProps) => {
  const filtered = disclaimers.filter((item): item is string => !!item)

  if (filtered.length === 0) {
    return null
  }

  return (
    // we use 40px pb instead of 48px because elements in the small print have 8px margin bottom.
    // 40px + 8px = 48px
    <div className={'mb-spacing-48 border-b pb-spacing-40 @[601px]:mb-spacing-40'}>
      <SmallPrint>
        {filtered.map((disclaimer, idx) => (
          <CmsContent
            key={`disclaimer-${idx}`}
            content={disclaimer}
          />
        ))}
      </SmallPrint>
    </div>
  )
}
